export function categoryDisplayLabel(offer: {
  category?: string | null
  category_label?: string | null
}): string | null {
  if (offer.category_label !== null && offer.category_label !== undefined && offer.category_label !== '') {
    return offer.category_label
  }

  if (offer.category !== null && offer.category !== undefined && offer.category !== '') {
    return offer.category
  }

  return null
}
